const { Client } = require('@twilio/conversations')

export const createChannel = async (token, s_id) => {
  try {
    const client = new Client(token);
    const retrieveChannel = await client.getConversationBySid(s_id);
    return retrieveChannel;
  } catch (error) {
    return new Promise((resolve, reject) => {
      reject('twilio not supported');
    });
  }
}

export const messageCount = async (channel) => {
  try {
    var messageCount = await channel.getMessagesCount();
    return messageCount;
  } catch (e) {
    console.log(e);
  }
}

export const prevMessage = async (messages) => {
  try {
    if (messages.hasPrevPage) {
      const prevMessages = await messages.prevPage();
      return prevMessages;
    }
    return "Yay! you have seen all the messages";
  } catch (e) {
    console.log(e);
  }
}

export const retreiveData = async (chanel) => {
  try {
    const messages = await chanel.getMessages();
    return messages;
  } catch (error) {
    return new Promise((resolve, reject) => {
      reject('there is an issue while fetching the messages');
    });
  }
}

export const sendMessage = async (messageData, channel, user) => {
  try {
    if (!messageData) {
      return;
    }
    if (messageData.attachment) {
      const formData = new FormData();
      formData.append('file', messageData.attachment);
      channel.sendMessage(formData, user);
      return;
    }
    if (messageData.comment) {
      channel.sendMessage(messageData.comment, user);
      return;
    }
    return true;
  } catch (error) {
    return new Promise((resolve, reject) => {
      reject('there is an error while sending the message');
    });
  }
}

export const getAllMembers = async (channel) => {
  try {
    var response = await channel.getParticipants()
    return response;
  } catch (e) {
    console.log(e);
  }
}
